import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { Filter } from '@pages/Admin/TransactionsPage/components/Content/components/Filter';
import { useModalContext } from '@providers/ModalProvider';

import { Content } from './styles/Content';
import { TProps } from './types/TProps';

export const AdminTransactionsFiltersModal = ({ onCancel, filter, filterOnChange, onSubmit }: TProps) => {
  const { closeModal } = useModalContext();

  return (
    <ModalWrapper width="400px" onCancel={onCancel}>
      <ModalTitle>Filters</ModalTitle>
      <Content>
        <Filter
          hideHeader
          filter={filter}
          filterOnChange={filterOnChange}
          handleSubmit={onSubmit}
          handleClose={closeModal}
        />
      </Content>
    </ModalWrapper>
  );
};
